import React, { lazy } from 'react';

const ConsultList = lazy(() => import("@/components/UserInfo/StaffInfo/consultList"));
const FormList = lazy(() => import("@/components/UserInfo/StaffInfo/formList"));
const TaskList = lazy(() => import("@/components/UserInfo/StaffInfo/taskList"));
const AttachmentList = lazy(() => import("@/components/UserInfo/StaffInfo/attachmentList"));
const DoctorCalendar = lazy(() => import("@/pages/doctor/calendar"));
const UserSetting = lazy(() => import("@/pages/doctor/userSetting"));
const Home = lazy(() => import("@/pages/doctor/home"));
const OperatingInformation = lazy(() => import('@/pages/doctor/home/operatingInformation'));
const DoctorHomePage = lazy(() => import('@/pages/doctor/home/homePage'));
const DoctorDialogue = lazy(() => import("@/pages/doctor/dialogue"));
const DoctorDialogueV2 = lazy(() => import("@/pages/doctor/dialogue/indexV2"));
const DoctorDialogueList = lazy(() => import("@/pages/doctor/dialogue/list"));
const CustomServiceDialogueList = lazy(() => import("@/pages/doctor/dialogue/customServiceList"));
const DoctorVideoConsult = lazy(() => import("@/pages/doctor/doctorVideoConsult"));
const DoctorVideoConsultChatgpt = lazy(() => import("@/pages/doctor/doctorVideoConsultChatgpt"));
const DoctorLogin = lazy(() => import("@/pages/doctor/login"));
const DoctorPatientInfo = lazy(() => import("@/pages/doctor/patientInfo"));
const DoctorPatientBaseInfo = lazy(() => import("@/pages/doctor/patientOnlyBaseInfo"));
const FormLibrary = lazy(() => import("@/pages/doctor/formLibrary"));
const DoctorUserInfo = lazy(() => import("@/pages/doctor/userInfo"));
const DoctorApprovedMemo = lazy(() => import("@/pages/doctor/approvedMemo"));
const SelfIntroAuditPage = lazy(() => import('@/pages/doctor/selfIntroAuditPage'));
const DoctorFormIframe = lazy(() => import('@/pages/doctor/formIframe'));
const ScheduleInfo = lazy(() => import('@/pages/doctor/scheduleInfo'));
const ExternsInfo = lazy(() => import('@/pages/doctor/externsInfo'));
const QimoUserInfo = lazy(() => import('@/pages/doctor/qimoUserInfo'));
const HealthRecordList = lazy(() => import('@/pages/doctor/healthRecordList'));
const RecordDetail = lazy(() => import('@/pages/doctor/healthRecordList/recordDetail'));
const DoctorAppointmentList = lazy(() => import('@/pages/doctor/AppointmentList'));
const DoctorAppointmentDetail = lazy(() => import('@/pages/doctor/AppointmentDetail'));
const DoctorRiskAttach = lazy(() => import('@/pages/doctor/riskAttach'));
const WorkOrderList = lazy(() => import('@/pages/doctor/WorkOrderList'));

const therapistRoutes = [
  { path: '/therapist/login', component: <DoctorLogin />, needInterceptor: false },
  {
    path: '/therapist/home', component: <Home />, children: [
      { path: '', component: <DoctorHomePage />, needInterceptor: true, index: 'true' },
      { path: 'user-manage', component: <DoctorDialogueList />, needInterceptor: true },
      { path: 'user-manage-service', component: <CustomServiceDialogueList />, needInterceptor: true },
      { path: 'work-order', component: <WorkOrderList />, needInterceptor: true },
      { path: 'appointment-list', component: <DoctorAppointmentList />, needInterceptor: true },
      { path: 'calendar', component: <DoctorCalendar />, needInterceptor: true },
      { path: 'user-setting', component: <UserSetting />, needInterceptor: true },
    ]
  },
  { path: '/therapist/consult-list', component: <ConsultList />, needInterceptor: true },
  { path: '/therapist/form-list', component: <FormList />, needInterceptor: true },
  { path: '/therapist/task-list', component: <TaskList />, needInterceptor: true },
  { path: '/therapist/attachment-list', component: <AttachmentList />, needInterceptor: true },
  { path: '/therapist/operating-information', component: <OperatingInformation />, needInterceptor: true },
  { path: '/therapist/dialogue', component: <DoctorDialogue />, needInterceptor: true },
  { path: '/therapist/dialogue-v2', component: <DoctorDialogueV2 />, needInterceptor: true },
  { path: '/therapist/doctor-video-consult', component: <DoctorVideoConsult />, needInterceptor: true },
  { path: '/therapist/doctor-video-consult-chatgpt', component: <DoctorVideoConsultChatgpt />, needInterceptor: true },
  { path: '/therapist/client-info', component: <DoctorPatientInfo />, needInterceptor: true },
  { path: '/therapist/client-base-info', component: <DoctorPatientBaseInfo />, needInterceptor: false },
  { path: '/therapist/form-library', component: <FormLibrary />, needInterceptor: true },
  { path: '/therapist/self-info', component: <DoctorUserInfo />, needInterceptor: true },
  { path: '/therapist/approved-memo', component: <DoctorApprovedMemo />, needInterceptor: true },
  { path: '/therapist/self-intro-audit', component: <SelfIntroAuditPage />, needInterceptor: true },
  { path: '/therapist/form-iframe', component: <DoctorFormIframe />, needInterceptor: true },
  { path: '/therapist/scheduleInfo', component: <ScheduleInfo />, needInterceptor: true },
  { path: '/therapist/externsInfo', component: <ExternsInfo />, needInterceptor: true },
  { path: '/therapist/health-record-list', component: <HealthRecordList />, needInterceptor: true },
  { path: '/therapist/record-detail', component: <RecordDetail />, needInterceptor: true },
  { path: '/therapist/qimo-user-info', component: <QimoUserInfo />, needInterceptor: true },
  { path: '/therapist/appoint-detail', component: <DoctorAppointmentDetail />, needInterceptor: true },
  { path: '/therapist/risk/:riskId/attach', component: <DoctorRiskAttach />, needInterceptor: true },
];

export default therapistRoutes;
